import script from "./ProductItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductItem.vue?vue&type=script&setup=true&lang=ts"

import "./ProductItem.vue?vue&type=style&index=0&id=6eaa6b66&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eaa6b66"]])

export default __exports__